import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { RevealLines, Reveal } from "@/components/Reveal";
import { waLink } from "@/config/site";

export const CtaBand = ({
  eyebrow = "Kontakt",
  titleLines = ["Lassen wir etwas", "wachsen."],
  text = "Erzählen Sie uns von Ihrem Gartenprojekt.",
}) => (
  <section className="relative overflow-hidden bg-[#17251C] py-28 md:py-44" data-testid="cta-band">
    <svg viewBox="0 0 1200 500" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
      <motion.path
        d="M-20 420C220 380 340 150 600 190 820 224 900 400 1220 300"
        fill="none"
        stroke="#93A387"
        strokeWidth="1"
        strokeOpacity="0.4"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 2.4, ease: "easeInOut" }}
      />
    </svg>

    <div className="relative mx-auto max-w-[1480px] px-5 md:px-10">
      <p className="eyebrow !text-[#DCCDB4]">{eyebrow}</p>
      <RevealLines
        lines={titleLines}
        as="h2"
        className="display-xl mt-6 max-w-4xl text-[12vw] leading-[0.9] text-[#F3EDE2] md:text-[6.4vw]"
      />
      <Reveal delay={0.2}>
        <p className="mt-8 max-w-lg text-base leading-relaxed text-[#DCCDB4] md:text-lg">{text}</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/kontakt" className="btn-primary !bg-[#F3EDE2] !text-[#17251C]" data-testid="cta-band-consultation">
            Kostenlose Beratung <ArrowUpRight size={15} />
          </Link>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline on-dark"
            data-testid="cta-band-whatsapp"
          >
            <MessageCircle size={15} /> WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
